interface SocialProofChipProps {
  chipLabel: string;
  position: "top" | "bottom";
  cardTitle: string;
}

const userIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00037 2.75C7.05876 2.75018 7.91638 3.60855 7.91638 4.66699C7.91621 5.72528 7.05865 6.58283 6.00037 6.58301C4.94193 6.58301 4.08355 5.72539 4.08337 4.66699C4.08337 3.60845 4.94182 2.75 6.00037 2.75ZM6.00037 8.08301C7.88708 8.08283 9.41621 6.55371 9.41638 4.66699C9.41638 2.78013 7.88719 1.25018 6.00037 1.25C4.11339 1.25 2.58337 2.78002 2.58337 4.66699C2.58355 6.55382 4.1135 8.08301 6.00037 8.08301ZM10.1664 12.667V14C10.1664 14.276 10.3904 14.4998 10.6664 14.5C10.9425 14.5 11.1664 14.2761 11.1664 14V12.667C11.1664 11.8273 10.8333 11.0216 10.2396 10.4277C9.64584 9.83395 8.8401 9.50009 8.00037 9.5H4.00037C3.16051 9.5 2.35497 9.83387 1.76111 10.4277C1.16724 11.0216 0.833374 11.8271 0.833374 12.667V14C0.833374 14.2761 1.05723 14.5 1.33337 14.5C1.60952 14.5 1.83337 14.2761 1.83337 14V12.667C1.83337 12.0924 2.06181 11.5411 2.46814 11.1348C2.87447 10.7284 3.42573 10.5 4.00037 10.5H8.00037C8.57488 10.5001 9.12634 10.7285 9.53259 11.1348C9.93872 11.5411 10.1664 12.0925 10.1664 12.667ZM13.9167 13.9997V12.6667C13.9163 12.2422 13.7754 11.8293 13.5153 11.4938C13.2552 11.1582 12.8903 10.9193 12.4792 10.8132C12.0782 10.7096 11.8367 10.3001 11.9401 9.89909C12.0437 9.49806 12.4532 9.25653 12.8542 9.36003C13.587 9.54923 14.2361 9.97682 14.6999 10.5749C15.1636 11.1731 15.4161 11.9088 15.4167 12.6657V13.9997C15.4167 14.4139 15.0809 14.7497 14.6667 14.7497C14.2525 14.7497 13.9167 14.4139 13.9167 13.9997ZM11.5192 3.49479C11.7801 3.83089 11.9215 4.24414 11.9216 4.6696C11.9216 5.09518 11.7802 5.50919 11.5192 5.84538C11.2584 6.18137 10.8932 6.42143 10.4812 6.52702C10.0799 6.62975 9.8375 7.03791 9.94015 7.43913C10.0428 7.84022 10.4512 8.08254 10.8523 7.98014C11.587 7.79202 12.2387 7.36436 12.7038 6.7653C13.169 6.16601 13.4216 5.42824 13.4216 4.6696C13.4215 3.91107 13.1689 3.17408 12.7038 2.57487C12.2386 1.97571 11.5871 1.54817 10.8523 1.36003C10.4511 1.25758 10.0428 1.49992 9.94015 1.90104C9.8377 2.30217 10.08 2.71045 10.4812 2.81315C10.8933 2.91877 11.2584 3.15873 11.5192 3.49479Z"
      fill="#008205"
    />
  </svg>
);

const SocialProofChip = ({
  chipLabel,
  position,
  cardTitle,
}: SocialProofChipProps) => {
  if (!chipLabel) return null;
  return (
    <div
      data-testid={`social-proof-chip-${position}-${cardTitle.toLowerCase()}`}
      className={`${
        position === "bottom" ? "pt-4 " : ""
      } flex  w-full items-center justify-center`}
    >
      <div
        className={`${
          position === "top"
            ? "absolute -top-[17px] outline outline-1 outline-offset-[-1px] outline-border-positive-secondary "
            : ""
        }
           px-2 py-1 flex gap-1 rounded-[120px] bg-surface-positive justify-center items-center text-center w-fit`}
      >
        {userIcon}
        <div className="justify-center text-text-positive text-3xs font-semibold leading-5">
          {chipLabel}
        </div>
      </div>
    </div>
  );
};
export default SocialProofChip;
